module.exports = __webpack_public_path__ + "media/images/checkout/challenger/learn_more_1-a0339fa913af87e53fab1b3744ce1c56.png";